<template>
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    @click="$emit('click')"
  >
    <path
      d="M4.22009 11.29L11.2901 4.22003C13.6401 1.88003 17.4301 1.88003 19.7801 4.22003C22.1201 6.56003 22.1201 10.36 19.7801 12.71L12.7101 19.78C10.3601 22.12 6.56009 22.12 4.22009 19.78C1.88009 17.43 1.88009 13.64 4.22009 11.29ZM5.64009 12.71C4.59009 13.75 4.24009 15.24 4.60009 16.57L10.5901 10.59L14.8301 14.83L18.3601 11.29C19.9301 9.73003 19.9301 7.20003 18.3601 5.64003C16.8001 4.07003 14.2701 4.07003 12.7101 5.64003L5.64009 12.71Z"
    />
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "ScriptIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
